import { CustomArray } from "../../../utility/common/CustomArray.js";


export class MapService {

    constructor() {

        this.serviceId = null;
        this.serviceName = null;
        this.serviceType = null;
        this.serviceTypeDesc = null;
        this.publishUrl = null;
        this.capabilities = null;
        this.layerNames = Array();
        this.matrixSetNames = new Array();

        this.source = null;
        this.layer = null;
    }

    getLayer(onAddcallback) {
        if (!this.layer) {
            if (this.serviceType && this.serviceType === MapServiceType.wmts) {
                this.layer = this.getWmtsLayer(onAddcallback);
            }
            else if (this.serviceType && this.serviceType === MapServiceType.vectorTile) {
                this.layer = this.getVectorTileLayer(onAddcallback);
            }
        }

        return this.layer;
    }


    getWmtsLayer(onAddcallback) {
        let wmtsLayer=null;
        let wmtsSource = this.getWmtsSource();
        if (wmtsSource) {
            wmtsLayer = new ol.layer.Tile(
                {
                    source: wmtsSource,
                    opacity: 1
                }
            );

            wmtsLayer.onAdd = function (map) {
                onAddcallback(map);
            }
        }

        return wmtsLayer;
    }

    getWmtsSource() {
        let self = this;
        let source = null;
        if (this.capabilities) {
            let options = ol.source.WMTS.optionsFromCapabilities(this.capabilities, {
                layer: self.layerNames[0],
                matrixSet: self.matrixSetNames[0]
            });

            source = new ol.source.WMTS(options);
        }

        return source;
    }

    getVectorTileLayer(onAddcallback) {
        let vtLayer = null;
        
        let vtSource = this.getVectorTileSource();
        if(vtSource)
        {
            vtLayer = new ol.layer.VectorTile({
                source: vtSource
            }
            );
    
            vtLayer.onAdd = function (map) {
                onAddcallback(map);
            }
        }

        return vtLayer;
    }


    getVectorTileSource() {
        let self = this;
        let vtSource = new ol.source.VectorTile({
            format: new ol.format.MVT(),
            url: self.publishUrl
        });

        return vtSource;
    }



    parseCapabilitiesXml() {
        let self = this;
        let xmlString = "../../../assets/river_extent_WMTSCapabilities.xml";
        let formatCapabilities = new ol.format.WMTSCapabilities();


        fetch(xmlString).then(function (response) {
            return response.text();
        }).then(function (text) {
            let capabilities = formatCapabilities.read(text);
            if (capabilities) {
                let contents = capabilities.Contents;
                if (contents) {
                    let layers = contents.Layer;
                    if (layers && layers.length > 0) {
                        let layerNameArray = new Array();

                        let tempLayerInfo = null;
                        for (let tempLayerIndex = 0; tempLayerIndex < layers.length; tempLayerIndex++) {
                            tempLayerInfo = layers[tempLayerIndex];
                            if (tempLayerInfo && tempLayerInfo.Identifier) {
                                layerNameArray.push(tempLayerInfo.Identifier);
                            }
                        }

                        self.layerNames = layerNameArray;
                    }

                    let matrixSets = contents.TileMatrixSet;
                    if (matrixSets && matrixSets.length > 0) {
                        let matrixsetArray = new Array();

                        let tempMatrixSetInfo = null;
                        for (let tempIndex = 0; tempIndex < matrixSets.length; tempIndex++) {
                            tempMatrixSetInfo = matrixSets[tempIndex];
                            if (tempMatrixSetInfo && tempMatrixSetInfo.Identifier) {
                                matrixsetArray.push(tempMatrixSetInfo.Identifier);
                            }
                        }

                        self.matrixSetNames = matrixsetArray;
                    }
                }
            }

            self.capabilities = capabilities;
            self.source = self.getWmtsSource();
        })

    }



}

export class MapServices extends CustomArray {
    constructor() {
        super();
    }

    classifyByType() {
        let classifies = new Array();
        let types = new Array();

        let tempService = null;
        let tempServiceType = null;
        for (let tempIndex = 0; tempIndex < this.objects.length; tempIndex++) {
            tempService = this.objects[tempIndex];
            if (!tempService) continue;

            tempServiceType = tempService.serviceType;

            if (types.indexOf(tempServiceType) == -1) {
                types.push(tempServiceType);
                classifies[tempServiceType] = new MapServices();
            }

            classifies[tempServiceType].push(tempService);
        }

        return classifies;
    }


    static mockDatas() {
        let services = new MapServices();


        let tempService = new MapService();

        tempService.serviceId = "edfa02c667704ec6977e744456760681";
        tempService.serviceName = "dx_vec_c";
        tempService.serviceType = "wmts";
        tempService.serviceTypeDesc = "wmts服务";
        tempService.publishUrl = "/dx_vec_c";
        tempService.parseCapabilitiesXml();
        services.push(tempService);


        tempService = new MapService();

        tempService.serviceId = "70fcdbaf750e4319a7f883e4ed318eff";
        tempService.serviceName = "vec_c";
        tempService.serviceType = "vectorTile";
        tempService.serviceTypeDesc = "矢量切片服务";
        tempService.publishUrl = "http://127.0.0.1:8080/service/vtpkExploded/VectorTileServer/tile/{z}/{y}/{x}.pbf";
        services.push(tempService);

        return services;
    }


}

export const MapServiceType =
{
    wmts: "wmts",

    vectorTile: "vectorTile"



}